import axios from 'axios';
import { useCallback } from 'react';

// eslint-disable-next-line import/no-unresolved
import { configSetting } from '../config';
import { HttpConfig } from '../models/https';
import { handleSubscriptionError, SUBSCRIPTION_USAGE_EVENT } from '../utils/subscriptionEvents';

const useHttps = () => {
  const sendRequest = useCallback(
    async (
      httpConfig: HttpConfig,
      callback: (data: any) => void,
      loadingFunc?: (value: boolean) => void,
      errorFunc?: (err: any) => void
    ) => {
      const apiUrl = `${configSetting.apiUrl}${httpConfig.url}`;

      const config = {
        ...httpConfig,
        url: apiUrl,
        headers: {
          'Content-Type': 'application/json',
          ...httpConfig.headers,
        },
      };

      try {
        if (loadingFunc) {
          loadingFunc(true);
        }

        const response = await axios(config);
        callback(response.data);
        if (httpConfig.method === 'post' && (/^jobs-service\/jobs\/?$/.test(httpConfig.url) ||
          /^jobs-service\/applications\/[^/]+\/apply$/.test(httpConfig.url))) {
          window.dispatchEvent(new Event(SUBSCRIPTION_USAGE_EVENT));
        }
        if (loadingFunc) {
          loadingFunc(false);
        }
      } catch (err: any) {
        if (!handleSubscriptionError(err?.response?.data) && errorFunc) {
          errorFunc(err);
        }
        if (loadingFunc) {
          loadingFunc(false);
        }
      }
    },

    []
  );
  return sendRequest;
};

export default useHttps;
